import { BASE_URL } from './API';

export async function refreshToken() {
  const token = localStorage.getItem('token');

  if (!token) throw new Error('No token found');

  try {
    const controller = new AbortController();

    // Set a timeout to abort the request if it takes too long
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

    const response = await fetch(`${BASE_URL}refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Refresh failed with status: ${response.status}`);
    }

    const res = await response.json();

    if (res.message !== 'success') {
      throw new Error('Failed to refresh token');
    }

    localStorage.setItem('token', res?.data?.access_token);
    localStorage.setItem('tokenExpiry', Date.now() + 23 * 60 * 60 * 1000);

    return res?.data?.access_token;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Refresh token request was cancelled');
    }
    throw error;
  }
}
